import { FirestoreDataConverter } from "firebase/firestore";
import { omit } from "lodash";
import moment from "moment";
import Conexao from "../models/conexao";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class ConexaoDb extends BaseDb<
  Conexao,
  { usuarioId: string; conexaoId: string }
> {
  _path: string = "usuarios/usuarioId/conexoes/conexaoId";
  getConverter(): FirestoreDataConverter<Conexao> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Conexao({
          id: snapshot.id,
          itemId: snapshot.get("itemId"),
          corretora: snapshot.get("corretora"),
          dataConexao: moment(snapshot.get("dataConexao").toDate()),
          dataAtualizacao: moment(snapshot.get("dataAtualizacao").toDate()),
          situacao: snapshot.get("situacao"),
          conta: snapshot.get("conta"),
          erro: snapshot.get("erro"),
          conexaoAntiga: !!snapshot.get("connectionKey"),
        }),
      toFirestore: (conexao) => toFirestore(omit(conexao, ["id"])),
    };
  }
}
